// Traduz a bolha da validacao nativa do navegador (SYN-134).
//
// O texto de "Please fill out this field." vem do NAVEGADOR, no idioma da interface dele — nao
// no idioma da pagina. Um cadastro inteiramente em portugues mostrava a bolha em ingles, e nao
// ha atributo HTML que resolva: so `setCustomValidity`.
//
// As mensagens chegam prontas em `data-required` / `data-email` / `data-checkbox`, traduzidas
// pelo I18n no servidor. O JS nao conhece idioma nenhum — se amanha entrar um sexto idioma,
// este arquivo nao muda.
//
// Politica: so escrevemos mensagem para as falhas que conhecemos. Para qualquer outra
// (`patternMismatch`, `tooShort`, `rangeOverflow`...) o silencio significa "deixa o navegador
// falar" — a frase nativa dele e mais especifica que qualquer generica nossa.
export default class extends HTMLElement {
  connectedCallback () {
    // `invalid` NAO borbulha — sem captura (o terceiro argumento) o listener no container
    // nunca veria o evento disparado no input.
    this.addEventListener('invalid', this.onInvalid, true)
    this.addEventListener('input', this.onEdit, true)
    this.addEventListener('change', this.onEdit, true)
  }

  disconnectedCallback () {
    // Higiene de ciclo de vida (o elemento pode ser descartado com a pagina). NAO e guarda
    // contra listener duplicado: `addEventListener` com o mesmo alvo, tipo, funcao e fase e
    // idempotente por especificacao, e `onInvalid`/`onEdit` sao class fields — uma referencia
    // estavel por instancia —, entao um re-connect nao empilharia nada mesmo sem isto.
    this.removeEventListener('invalid', this.onInvalid, true)
    this.removeEventListener('input', this.onEdit, true)
    this.removeEventListener('change', this.onEdit, true)
  }

  onInvalid = (event) => {
    // Zera ANTES de ler a validade. `setCustomValidity` so mexe na flag `customError` — as
    // nativas (`valueMissing`, `typeMismatch`, ...) o navegador recalcula a cada acesso, entao
    // limpar aqui nao afrouxa validacao nenhuma. O que isto evita: uma mensagem nossa de um
    // submit anterior sobreviver a um preenchimento que nao disparou `input` nem `change`
    // (gerenciador de senha escrevendo `el.value` direto, `form.reset()`) e travar o envio de
    // um campo visivelmente preenchido, com a bolha errada e sem caminho de volta.
    event.target.setCustomValidity('')

    const message = this.messageFor(event.target)

    if (message) event.target.setCustomValidity(message)
  }

  // Limpa em toda edicao. Sem isto a mensagem GRUDA: `customError` nao se reavalia sozinha, e o
  // campo continuaria invalido depois de corrigido.
  onEdit = (event) => event.target.setCustomValidity?.('')

  messageFor (field) {
    const validity = field.validity

    if (!validity) return ''

    if (validity.valueMissing) {
      // Caixa de marcar nao se "preenche" — a frase de campo de texto vira uma instrucao que
      // nao da para executar, e e o ultimo portao antes do funil pago (aceite do art. 8 da
      // LGPD). Os navegadores tem frase propria para este caso; aqui ela vem traduzida.
      const marcavel = field.type === 'checkbox' || field.type === 'radio'

      return (marcavel ? this.dataset.checkbox : this.dataset.required) || ''
    }

    if (validity.typeMismatch && field.type === 'email') return this.dataset.email || ''

    return ''
  }
}
